import { NgClass } from "@angular/common";
import { afterNextRender, AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'corp-control-title',
    standalone: true,
    templateUrl: 'corp-control-title.component.html',
    imports: [NgClass, TranslateModule]
  })

  export class CorpControlTitleComponent implements OnInit, AfterViewInit, AfterViewChecked  {
    titleWidth = 0;
    @Input("corp-size") corpSize: string | null = null;
    @Input("corp-title") corpTitle: string | null = null;
    @Input("corp-disabled") corpDisabled: boolean = false;

    @ViewChild('titleRef')
    set titleRef(el: ElementRef | undefined) {
      
      if (el) {
        
        this.titleWidth = el.nativeElement.offsetWidth + 6;
        this.cdr.detectChanges(); // clé
      }
    }
   

    constructor(private cdr: ChangeDetectorRef){  }

    ngOnInit(): void {

    }

    ngAfterViewInit() {

        
    }

    ngAfterViewChecked() { 

      
    }

}
